import React from 'react';
import clsx from 'clsx';
import { MathUtil } from '../../../../../../common/utils/mathUtil';

const DoubleDragonBarChart = ({ count = {} }) => {
    return (
      <>
          <div className="data_summary">
              <h3 className="tit">1번볼 (빨간색)</h3>
              <div className="chart">
                  <dl
                    className={clsx(
                      'bar',
                      'ODD',
                      parseInt(count.ball_1_odd_count) >
                      parseInt(count.ball_1_even_count) && 'on'
                    )}
                  >
                      <dt>홀</dt>
                      <dd>
                          <span className="num">{count.ball_1_odd_count}</span>
                          <span className="per">({count.ball_1_odd_percent}%)</span>
                      </dd>
                  </dl>
                  <dl
                    className={clsx(
                      'bar',
                      'EVEN',
                      parseInt(count.ball_1_odd_count) <
                      parseInt(count.ball_1_even_count) && 'on'
                    )}
                  >
                      <dt>짝</dt>
                      <dd>
                          <span className="num">{count.ball_1_even_count}</span>
                          <span className="per">({count.ball_1_even_percent}%)</span>
                      </dd>
                  </dl>
              </div>
          </div>
          <div className="data_summary">
              <h3 className="tit">2번볼 (노란색)</h3>
              <div className="chart">
                  <dl
                    className={clsx(
                      'bar',
                      'ODD',
                      parseInt(count.ball_2_odd_count) >
                      parseInt(count.ball_2_even_count) && 'on'
                    )}
                  >
                      <dt>홀</dt>
                      <dd>
                          <span className="num">{count.ball_2_odd_count}</span>
                          <span className="per">({count.ball_2_odd_percent}%)</span>
                      </dd>
                  </dl>
                  <dl
                    className={clsx(
                      'bar',
                      'EVEN',
                      parseInt(count.ball_2_odd_count) <
                      parseInt(count.ball_2_even_count) && 'on'
                    )}
                  >
                      <dt>짝</dt>
                      <dd>
                          <span className="num">{count.ball_2_even_count}</span>
                          <span className="per">({count.ball_2_even_percent}%)</span>
                      </dd>
                  </dl>
              </div>
          </div>
      </>
    );
};

export default DoubleDragonBarChart;
